// extracted by mini-css-extract-plugin
export default {"LiveChatConversation":"LiveChatConversation_LiveChatConversation__YOPCK","heading":"LiveChatConversation_heading__zQCVp"};